import React, { Fragment } from "react";

import testimonial1Src from "../images/testimonial-1.png";
import testimonial2Src from "../images/testimonial-2.png";
import testimonial3Src from "../images/testimonial-3.png";
import testimonial4Src from "../images/testimonial-4.png";
import testimonial5Src from "../images/testimonial-5.png";
import testimonial6Src from "../images/testimonial-6.png";
import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { useMindspaceAnalytics } from "./mindspace_analytics";
import { Spacer } from "../spacer";
import { Text } from "../text";
import { partnerConfig } from "./mindspace_partner_config";
import { Testimonial } from "../../data/partners";
import { lazyWithRetry } from "../../core/lazy_with_retry";

const Theme = lazyWithRetry(() => import("./mindspace_theme"));

const faqs = [
  {
    question: "Do I need to book in advance?",
    answer:
      "You will need to book ahead of arriving in order to secure your office. When possible, we will accommodate walk-ins according to availability.",
  },

  {
    question: "Can I roll over any unused entries into the next month?",
    answer:
      "Mindpass Daily office is valid for your booked date only and cannot be rolled over into the following month.",
  },

  {
    question: "Can I cancel my daily office purchase?",
    answer:
      "Mindpass daily office is non-refundable, and cannot be redeemed or used to purchase any other Mindspace products.",
  },

  {
    question:
      "I accidentally booked for the wrong date; can I modify my booking?",
    answer:
      "Yes. Please contact our support and we will assist in modifying your order.",
  },

  {
    question: "Can I share my daily office with other people?",
    answer:
      "You can share your office with your team, up to 4 people per order.",
  },

  {
    question: "Can I use the meeting rooms?",
    answer:
      "If you would like to use a meeting room, you will need to rent out a meeting room separately. Please contact our staff for availability and pricing options.",
  },

  {
    question:
      "Can I meet with clients or bring a guest into the Mindspace lounges and communal area?",
    answer:
      "Your daily office is individual and doesn’t cover guests. To secure access for a guest and for private meetings, you can book a meeting room based on availability.",
  },

  {
    question:
      "If I purchased a daily office, can I bring more than 3 people to work with me on that day?",
    answer:
      "No. the day office can occupy up to 4 people. Any additional colleagues, who wish to join you working at Mindspace that day, will be required to purchase a Mindpass daily.",
  },

  {
    question: "Can I use the same office for consecutive days?",
    answer:
      "You are not allocated a specific office when you purchase your daily office, however, you can ask the local community management team to check if you can use the same office on consecutive days. This will be subject to availability.",
  },

  {
    question: "When does my agreement start and end?",
    answer:
      "Your daily office will be available to you from 9 am till 6 pm on regular business days.",
  },
];

const testimonials: Testimonial[] = [
  {
    testimonial:
      "What I like the most about Mindspace is the good exchange we can have here with a lot of different companies and young minds. Seriousness on the one hand, young and vital on the other.",
    companyTitle: "Director Corporate Affairs at Samsung",
    name: "Steffen Ganders",
    companyLogo: testimonial5Src,
  },
  {
    testimonial:
      "My Berlin centrepiece of living is probably 20-25 min around Mindspace. What feels like living in a village where Mindspace plays a big role.",
    companyTitle: "Strategic Investments",
    name: "Carl-Luis Rieger",
    companyLogo: testimonial1Src,
  },
  {
    testimonial:
      "We love Mindspace. It is one of the best things that our company ever did for us.",
    companyTitle: "Group Creative Director",
    name: "Vanessa Roberts",
    companyLogo: testimonial2Src,
  },
  {
    testimonial:
      "The impeccable design and the productive work atmosphere at Mindspace led us to relocate our very own Berlin team to the Mindspace location in our building, a decision we are extremely happy about.",
    companyTitle: "Senior Director Development & Leasing",
    name: "Peter Roers",
    companyLogo: testimonial3Src,
  },
  {
    testimonial:
      "The thing that I love about Mindspace is basically: you sign a contract, you get the key, you open your door and you can start working from the second you enter your room. It is really right away and that is amazing.",
    companyTitle: "Founder of MBRC The Ocean GmbH",
    name: "Sven Jacobi",
    companyLogo: testimonial4Src,
  },
  {
    testimonial:
      "“When I walk into Mindspace, I just wake up, because of this energy that I can’t really tangibly grasp, but there is something about it that sets my mood and the attitude for the day,",
    companyTitle: "Sales at Kizen",
    name: "Hanna Jung",
    companyLogo: testimonial6Src,
  },
];

export function OfferingMindspaceDailyOffice() {
  useMindspaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections={false}
        partnerConfig={partnerConfig}
        data={{
          title: "Mindspace Daily Office - Take a private office for a day",
          description: (
            <Fragment>
              <Text>
                Mindspace daily office is a private office designed to fit up to
                4 people that allows you to work from Mindspace on an on-demand
                basis. Grant yourself a professional and inspiring working
                environment for a day, whenever you see fit.
              </Text>
              <Spacer size={8} />
              <Text>
                Choose your location, book your date and enjoy the perks of
                working at a fully equipped office with all essential services
                included, from 9am- 6pm on regular business days.
              </Text>
            </Fragment>
          ),
          amenitiesDescription:
            "Our community management team is available to help with any requests or administrative services needed.",
          faqs,
          testimonials: testimonials,
          generalInfo: {
            title: `Health & safety`,
            description: `At Mindspace, we are committed to delivering both an exceptional service and a safe workspace for our members:`,
            bulletPoints: [
              {
                text: "Offices and workstations are cleaned and sanitized on a frequent basis",
              },
              {
                text: "All Mindspace workspaces are in line with the safety rules and guidelines of the “Mindspace Seal”",
              },
            ],
          },
        }}
      />
    </Fragment>
  );
}
